function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#72246C",
  id: "5t74ys6rja",
  d: "M2 8H0v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2H2V8zm15-4V2c0-1.11-.89-2-2-2h-4C9.89 0 9 .89 9 2v2H4v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V4h-5zm-6-2h4v2h-4V2zm9 13H6V6h14v9zm-7-2.5c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z"
});
const SvgNewProductBundleProducts = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNewProductBundleProducts, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/new-product-bundle-products.e145c2b7.svg";
export { ForwardRef as ReactComponent };